import { render, staticRenderFns } from "./StadiumUpdateForm.vue?vue&type=template&id=4ead280a&"
import script from "./StadiumUpdateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ead280a')) {
      api.createRecord('4ead280a', component.options)
    } else {
      api.reload('4ead280a', component.options)
    }
    module.hot.accept("./StadiumUpdateForm.vue?vue&type=template&id=4ead280a&", function () {
      api.rerender('4ead280a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumUpdateForm.vue"
export default component.exports